import { render } from "./InternalOrders.vue?vue&type=template&id=4addacf7&scoped=true"
import script from "./InternalOrders.vue?vue&type=script&lang=js"
export * from "./InternalOrders.vue?vue&type=script&lang=js"

import "./InternalOrders.vue?vue&type=style&index=0&id=4addacf7&scoped=true&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4addacf7"]])

export default __exports__